import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { storage } from '@/utils/storage';
import { projectName } from '@/utils/config';

export default [
  {
    path: '/IFPageOneHFortyFivePreLogin',
    name: 'IFPageOneHFortyFivePreLogin',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/preLogin.vue'),
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 20230727 返回拦截下载页 */
      if (
        from.path === '/IFPageOneHFortyFiveLogin' ||
        from.path === '/IFPageOneHFortyFiveLoginSecond'
      ) {
        window.history.back();
      } else {
        next();
      }
    },
  },
  {
    path: '/IFPageOneHFortyFiveLogin',
    name: 'pageOneHFortyFiveLogin',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/login.vue'),
  },
  {
    path: '/IFPageOneHFortyFiveLoginLoading',
    name: 'pageOneHFortyFiveLoginLoading',
    meta: {
      title: '我的额度',
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/loginLoading.vue'),
  },
  {
    path: '/IFPageOneHFortyFiveLeaveInfo',
    name: 'pageOneHFortyFiveLeaveInfo',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/leaveInfo.vue'),
  },
  {
    path: '/IFPageOneHFortyFiveResult',
    name: 'pageOneHFortyFiveResult',
    meta: {
      title: projectName,
    },
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/result.vue'),
  },
  {
    path: '/IFPageOneHFortyFiveLoading',
    name: 'pageOneHFortyFiveLoading',
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/loading.vue'),
    meta: {
      title: '额度检测',
    },
  },
  {
    path: '/IFPageOneHFortyFiveLoginSecond',
    name: 'pageOneHFortyFiveLoginSecond',
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/loginSecond.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyFiveOnline',
    name: 'pageOneHFortyFiveOnline',
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/online.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      /* 网贷来源页 */
      if (from.path == '/IFPageOneHFortyFiveLoginSecond') {
        storage.setItem('onlineGoApply', null);
      } else {
        to.query.time = `${new Date().getTime()}`;
      }
      next();
    },
  },
  {
    path: '/IFPageOneHFortyFiveGuide',
    name: 'pageOneHFortyFiveLoginGuide',
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/guide.vue'),
    meta: {
      title: projectName,
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      to.query.formUrl = from.path;
      next();
    },
  },
  /*{
    path: '/IFPageOneHFortyFiveCar',
    name: 'pageOneHFortyFiveCar',
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/car.vue'),
    meta: {
      title: '补充留资',
    },
  },
  {
    path: '/IFPageOneHFortyFiveCarDetails',
    name: 'pageOneHFortyFiveCarDetails',
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/carDetails.vue'),
    meta: {
      title: '申请结果',
    },
  },*/
  {
    path: '/IFPageOneHFortyFiveBlank',
    name: 'pageOneHFortyFiveBlank',
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/blank.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyFiveOnlineTab',
    name: 'pageOneHFortyFiveOnlineTab',
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/onlineTab.vue'),
    meta: {
      title: projectName,
    },
  },
  {
    path: '/IFPageOneHFortyFiveOnlineAd',
    name: 'pageOneHFortyFiveOnlineAd',
    component: () => import('@/pages/pageListAll/pageOneHFortyFive/onlineAd.vue'),
    meta: {
      title: projectName,
    },
  },
];
